import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from 'src/components/loading-screen';
// auth
import { AuthGuard } from 'src/auth/guard';



const TrainingRequestListViewStore = lazy( () =>
       import( 'src/pages/trainingrequest/view/trainingRequestList/trainingRequestListView' ).then( ( module ) => ( {
              default: module.TrainingRequestListViewStore,
       } ) )
);


const TrainingFormationReservationListViewStore = lazy( () =>
       import( 'src/pages/trainingFormationReservationList/view/list/trainingFormationReservationList' ).then( ( module ) => ( {
              default: module.TrainingFormationReservationListViewStore,
       } ) )
);



const TrainingFormationsPlaning = lazy( () =>
       import( 'src/pages/trainingFormationsPlaning/view/list/trainingFormationsPlaning' ).then( ( module ) => ( {
              default: module.TainingFormationsPlaningViewStore
       } ) )
);




const KanbanView = lazy( () =>
       import( 'src/pages/formationkanban/view/kanban-view' ).then( ( module ) => ( {
              default: module.KanbanViewStore
       } ) )
);



// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy( () =>
       import( 'src/layouts/dashboard/layout' ).then( ( module ) => ( {
              default: module.DashboardLayoutStore,
       } ) )
);




export const formationsRoutesOrganization = [


       {
              path: 'organization/registration-requests',
              element: (
                     <AuthGuard allowedRoles={['organization', 'manager']}>
                     <DashboardLayoutStore>
                            <Suspense fallback={ <LoadingScreen /> }>
                                   <Outlet />
                            </Suspense>
                     </DashboardLayoutStore>
                     </AuthGuard>
              ),
              children: [
                     { element: <TrainingRequestListViewStore />, index: true },
                     { path: 'reservationList', element: <TrainingFormationReservationListViewStore /> },
                     // { path: 'profile', element: <ProfileContributorView /> },
              ],
       },

       {
              path: 'organization/planning',
              element: (
                     <AuthGuard allowedRoles={['organization', 'manager']}>
                     <DashboardLayoutStore>
                            <Suspense fallback={ <LoadingScreen /> }>
                                   <Outlet />
                            </Suspense>
                     </DashboardLayoutStore>
                     </AuthGuard>
              ),
              children: [
                     { element: <KanbanView />, index: true },
                     { path: 'reservationList', element: <TrainingFormationReservationListViewStore /> },
                     { path: 'initPage', element: <TrainingFormationsPlaning /> },
                     // { path: 'profile', element: <ProfileContributorView /> },
              ],
       },
];




export const formationsRoutes = [


       {
              path: 'organization/registration-requests',
              element: (
                     <AuthGuard allowedRoles={['organization', 'manager']}>
                     <DashboardLayoutStore>
                            <Suspense fallback={ <LoadingScreen /> }>
                                   <Outlet />
                            </Suspense>
                     </DashboardLayoutStore>
                     </AuthGuard>
              ),
              children: [
                     { element: <TrainingRequestListViewStore />, index: true },
                     { path: 'reservationList', element: <TrainingFormationReservationListViewStore /> },
                     // { path: 'profile', element: <ProfileContributorView /> },
              ],
       },

       {
              path: 'organization/planning',
              element: (
                     <AuthGuard allowedRoles={['organization', 'manager']}>
                     <DashboardLayoutStore>
                            <Suspense fallback={ <LoadingScreen /> }>
                                   <Outlet />
                            </Suspense>
                     </DashboardLayoutStore>
                     </AuthGuard>
              ),
              children: [
                     { element: <KanbanView />, index: true },
                     { path: 'initPage', element: <TrainingFormationsPlaning /> },
                     // { path: 'profile', element: <ProfileContributorView /> },
              ],
       },
];
